// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_i7-0";